//Bootstrap
import 'bootstrap/js/src/collapse'
import 'bootstrap/js/src/alert'
import 'bootstrap/js/src/modal'

//Slick
import 'slick-carousel/slick/slick'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'

//SHUFFLE LETTERS
import './shuffleletters'

//ANIMTION ON SCROLL TRIGGER for Jquery
$.fn.visible = function(partial) {
    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};
